module.exports = __webpack_public_path__ + "img/homeBanner.fa6a0d80.jpg";